import { AgreedVolumePerformance } from "@/gql/graphql";
import { Text } from "@stenajs-webui/core";
import {
  createColumnConfig,
  StandardTable,
  StandardTableConfig,
} from "@stenajs-webui/grid";
import { cssColor } from "@stenajs-webui/theme";
import _ from "lodash";

type TableRow = {
  routePairCode: string;
  agreedVolume: number;
  shippedVolume: number;
  performanceInPercent: number;
};
type ColumnKeys = keyof TableRow;

const tableConfig: StandardTableConfig<TableRow, ColumnKeys> = {
  initialSortOrder: "routePairCode",
  keyResolver: (item) => item.routePairCode,
  columns: {
    routePairCode: createColumnConfig((item) => item.routePairCode, {
      columnLabel: "Route",
    }),
    agreedVolume: createColumnConfig((item) => item.agreedVolume, {
      columnLabel: "Agreed volume",
    }),
    shippedVolume: createColumnConfig((item) => item.shippedVolume, {
      columnLabel: "Shipped volume",
    }),
    performanceInPercent: createColumnConfig(
      (item) => item.performanceInPercent,
      {
        columnLabel: "Performance",
        renderCell: ({ item }) => (
          <Text
            color={
              item.performanceInPercent < 95
                ? cssColor("--lhds-color-red-600")
                : cssColor("--lhds-color-ui-900")
            }
          >
            {item.performanceInPercent} %
          </Text>
        ),
      }
    ),
  },
  columnOrder: [
    "routePairCode",
    "agreedVolume",
    "shippedVolume",
    "performanceInPercent",
  ],
};

interface Props {
  data?: AgreedVolumePerformance[];
  loading: boolean;
}

export const AgreedVolumePerformanceTable = ({ data, loading }: Props) => {
  return <StandardTable loading={loading} config={tableConfig} items={data} />;
};
